import { render } from "./TotalSpecification.vue?vue&type=template&id=0583ddf1&scoped=true"
import script from "./TotalSpecification.vue?vue&type=script&lang=js"
export * from "./TotalSpecification.vue?vue&type=script&lang=js"

import "@/assets/css/print.css?vue&type=style&index=0&id=0583ddf1&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0583ddf1"]])

export default __exports__